import NoContent from './NoContent'

export default NoContent
